import { createPatchAPI } from '@cuemath/rest-api';
import { BASE_URL } from 'constants/api';

const { usePatch: useReviewEventPatch } = createPatchAPI({
  getURL: eventId => `${BASE_URL}/teacher-classroom-review-events/${eventId}/`,
});

export { useReviewEventPatch };
